<template>
  <NConfigProvider v-bind="{ theme: darkTheme, themeOverrides: theme }">
    <NMessageProvider :duration="5000" :keep-alive-on-hover="true">
      <div style="position: relative">
        <Blocker />
        <Layout />
      </div>
    </NMessageProvider>
  </NConfigProvider>
</template>

<script setup>
import { NConfigProvider, NMessageProvider, darkTheme } from "naive-ui";
import { onMounted, shallowRef, watch } from "vue";
import { useRoute } from "vue-router";
import Blocker from "./components/Blocker.vue";
import LayoutDefault from "./layouts/Default.vue";
import { addScriptElement, addLinkElement } from "./dom";
import theme from "./theme.js";

const Layout = shallowRef(LayoutDefault);
const route = useRoute();
watch(
  () => route.meta.Layout,
  // eslint-disable-next-line no-unused-vars
  (NewLayout, OldLayout) => {
    Layout.value = NewLayout || LayoutDefault;
  }
);

onMounted(() => {
  addLinkElement({
    rel: "stylesheet",
    href: "/locomotive-scroll/5.0.0-beta.21/locomotive-scroll.css",
  });
  addScriptElement({
    src: "/locomotive-scroll/5.0.0-beta.21/locomotive-scroll.min.js",
    id: "locamotive-scroll",
    // defer: true,
  }).then(() => {
    // eslint-disable-next-line no-undef
    const locomotiveScroll = new LocomotiveScroll({
    });
  });
});
</script>

<style src="modern-normalize/modern-normalize.css"></style>
<style lang="scss" src="./styles/global.scss"></style>
<style lang="scss" src="./styles/text.scss"></style>
<style lang="scss" src="./styles/buttons.scss"></style>
<style lang="scss" src="./styles/fx.scss"></style>
<style lang="scss" src="./styles/fx-outline.scss"></style>
